import { NavLink } from "react-router-dom";
import logo from "../../Images/icons/logo.png";
import NotificationDrawer from "../Drawer/NotificationDrawer";
import dataProvider from "../../Images/image/dataProvider.png";
import {
  FaLogout, FaTranslate,
  FaUser,
  FaVerificationPending,
  FaEditVehicle, FaAdsIcon,
  FaPartnersIcon,
  FaContact,
  FaMessanger, FaCustomNotification,
  FaBrokerManagementIcon,
  FaOurPartnersIcon
} from "../../Images/icon";
import API from "../../../api/axios";
import { APP_URLS } from "../../../api/url";
import { toast } from "react-toastify";
import { Tooltip } from "@mui/material";
import { SVGLinkWrapper, MenuWrapper } from "./Styles/Styles";

import SubsidiarySubMenu from "./Components/SubsidiarySubMenu";
import AuctionSubMenu from "./Components/AuctionSubMenu";
import HotdealsSubMenu from "./Components/HotdealsSubMenu";
import PlansSubMenu from "./Components/PlansSubMenu";
import LegalDocsSubMenu from "./Components/LegalDocsSubMenu";
import SettingsSubMenu from "./Components/SettingsSubMenu";
import ForumSubMenu from "./Components/ForumSubMenu";
import MyProfileSubMenu from "./Components/MyProfileSubMenu";
import FinanceSubMenu from "./Components/FinanceSubMenu";
import ReportedSubMenu from "./Components/ReportedSubMenu";
import { APIError } from "../../../core/utils";

const permission = JSON.parse(localStorage.getItem("permissions")) || [];

//Module Access
const classicAdsAccess = permission.find((o) => o.slug === "classic_ads");
const usersAccess = permission.find((o) => o.slug === "users");
const verifyUser = permission.find((o) => o.slug === "verify_user");
const validateUser = permission.find((o) => o.slug === "verify_nomad_user");
const tanslationAccess = permission.find((o) => o.slug === "translation");
const vehicleManagementAccess = permission.find((o) => o.slug === "vehicle_management");
const partnerAccess = permission.find((o) => o.slug === "partner");
const importedDealer = permission.find((o) => o.slug === "imported_dealer");
const contactUs = permission.find((o) => o.slug === "contact_us");
const chats = permission.find((o) => o.slug === "chats");
const ourPartnersAccess = permission.find((o) => o.slug === "manage_subsidiary");
const customNotifications = permission.find(
  (o) => o.slug === "custom_notifications"
);
const leadsManagement = permission.find((o) => o.slug === "leads_management");

const Menu = () => {

  const logout = () => {
    const device_id = JSON.parse(localStorage.getItem("deviceToken"));
    API.get(APP_URLS.LOGOUT + `?device_id=${device_id}&app_type=1`)
      .then((res) => {
        const resp = res.data;
        if (resp) {
          localStorage.clear();
          window.location.href = "/login";
        } else {
          toast.error(resp.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(function (error) {
        toast.error(APIError(error), {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  return (
    <MenuWrapper>

      <div className="navigation-and-logo-container">
        <div className="logo-container">
          <NavLink to="/">
            <img src={logo} alt="CarToBike Admin" />
          </NavLink>
        </div>

        <div className="navigation-container">

          <AuctionSubMenu />

          <HotdealsSubMenu />

          {/* Classic Ads */}
          {classicAdsAccess &&
            classicAdsAccess?.permissions?.find((o) => o.slug === "read") ? (
            <Tooltip title="Classic Ads" placement="right">
              <SVGLinkWrapper
                to="/classic-ads"
              >
                <FaAdsIcon />
              </SVGLinkWrapper>
            </Tooltip>
          ) : (
            ""
          )}

          {/* Pending Verification */}
          {(verifyUser &&
            verifyUser?.permissions?.find((o) => o.slug === "read")) ||
            (validateUser &&
              validateUser?.permissions?.find((o) => o.slug === "read")) ? (
            <Tooltip title="Pending Verification " placement="right">
              <SVGLinkWrapper
                to="/pending-verifications"
              >
                <FaVerificationPending />
              </SVGLinkWrapper>
            </Tooltip>
          ) : (
            ""
          )}

          {/* Users */}
          {usersAccess &&
            usersAccess?.permissions?.find((o) => o.slug === "read") ? (
            <Tooltip title="Users" placement="right">
              <SVGLinkWrapper to="/users">
                <FaUser />
              </SVGLinkWrapper>
            </Tooltip>
          ) : (
            ""
          )}

          <SubsidiarySubMenu />

          <PlansSubMenu />

          <FinanceSubMenu />

          {customNotifications &&
            customNotifications?.permissions?.find(
              (o) => o.slug === "read"
            ) && (
              <Tooltip title="Custom Notifications" placement="right">
                <SVGLinkWrapper
                  to="/custom-notifications"
                >
                  <FaCustomNotification />
                </SVGLinkWrapper>
              </Tooltip>
            )}

          {/* Messenger */}
          {chats && chats?.permissions?.find((o) => o.slug === "read") && (
            <Tooltip title="Messenger" placement="right">
              <SVGLinkWrapper
                to="/messenger"
              >
                <FaMessanger />
              </SVGLinkWrapper>
            </Tooltip>
          )}

          {/* Vehicles Management */}
          {vehicleManagementAccess &&
            vehicleManagementAccess?.permissions?.find(
              (o) => o.slug === "read"
            ) ? (
            <Tooltip title="Vehicles Management" placement="right">
              <SVGLinkWrapper
                to="/vehicles-management"
              >
                <FaEditVehicle />
              </SVGLinkWrapper>
            </Tooltip>
          ) : (
            ""
          )}

          {/* Translation */}
          {tanslationAccess &&
            tanslationAccess?.permissions?.find((o) => o.slug === "read") ? (
            <Tooltip title="Translation" placement="right">
              <SVGLinkWrapper
                to="/translation"
                onClick={() => {
                  localStorage.setItem("Translation", "Languages");
                }}
              >
                <FaTranslate />
              </SVGLinkWrapper>
            </Tooltip>
          ) : (
            ""
          )}

          <ReportedSubMenu />

          {/* Data Provider */}
          {importedDealer &&
            importedDealer?.permissions?.find((o) => o.slug === "read") && (
              <Tooltip title="Data Provider" placement="right">
                <SVGLinkWrapper
                  to="/data-provider"
                >
                  <img src={dataProvider} alt="" role="button" />
                </SVGLinkWrapper>
              </Tooltip>
            )}

          {/* Dealer API lives in the Dealers submenu (SubsidiarySubMenu) — the top-level column
              already overflows its scroll container, so a new icon there is below the fold. */}

          <SettingsSubMenu />

          {/* Contact us */}
          {contactUs &&
            contactUs?.permissions?.find((o) => o.slug === "read") && (
              <Tooltip title="Contact Us" placement="right">
                <SVGLinkWrapper
                  to="/contacts"
                >
                  <FaContact />
                </SVGLinkWrapper>
              </Tooltip>
            )}

          {/* Partners */}
          {partnerAccess &&
            partnerAccess?.permissions?.find((o) => o.slug === "read") ? (
            <Tooltip title="Partners" placement="right">
              <SVGLinkWrapper to="/partners">
                <FaPartnersIcon />
              </SVGLinkWrapper>
            </Tooltip>
          ) : (
            ""
          )}

          {ourPartnersAccess &&
            ourPartnersAccess?.permissions?.find((o) => o.slug === "read") ? (
            <Tooltip title="Our Partners" placement="right">
              <SVGLinkWrapper to="/our-partners">
                <FaOurPartnersIcon />
              </SVGLinkWrapper>
            </Tooltip>
          ) : (
            ""
          )}


          <LegalDocsSubMenu />

          <ForumSubMenu />

          {leadsManagement &&
            leadsManagement?.permissions?.find((o) => o.slug === "read") && (
              <Tooltip title="Broker Management" placement="right">
                <SVGLinkWrapper to="/broker-management">
                  <FaBrokerManagementIcon />
                </SVGLinkWrapper>
              </Tooltip>
            )}



        </div>

      </div>

      <div className="footer-container">

        <NotificationDrawer />

        <MyProfileSubMenu />

        <FaLogout onClick={logout} className="logout" />

      </div>

    </MenuWrapper>
  );
};

export default Menu;
